import React, { useEffect, useState, memo } from "react";
import { Grid, Button, TextField, InputAdornment } from "@material-ui/core";
import { Slider, Rail, Handles, Tracks, Ticks } from "react-compound-slider";
import { MuiRail, MuiHandle, MuiTrack, MuiTick } from "./components";
import BarChart from "./BarChart";

const HistoSlider = ({ data }) => {

    const [state, setState] = useState(null);

    useEffect(() => {
        let sortedData = data.slice().sort((a, b) => a - b);
        let range = [sortedData[0], sortedData[sortedData.length - 1]];
        const tState = {
            domain: range,
            update: range,
            values: range,
            inputValues: range
        };
        setState(tState);
    }, [data]);


    if (state == null) {
        return (<></>);
    }

    console.log("histogram render")
    return (
        <Grid container>
            <Grid item xs={12}>
                <div style={{ paddingLeft: "15px", paddingRight: "15px", width: "100%", height: "50%" }}>
                    <BarChart
                        data={data}
                        highlight={state.update}
                        domain={state.domain}
                    />
                    <Slider
                        mode={3}
                        step={1}
                        domain={state.domain}
                        rootStyle={{
                            position: "relative",
                            width: "100%"
                        }}
                        onUpdate={update => setState(a => ({ ...a, update, inputValues: update}) )
                        }

                        //onUpdate={update =>
                        //    this.setState({ update, inputValues: update })
                        //}
                        onChange={values => setState(a => ({ ...a, values }))}
                        //onChange={values => this.setState({ values })}
                        values={state.values}
                    >
                        <Rail>
                            {({ getRailProps }) => <MuiRail getRailProps={getRailProps} />}
                        </Rail>
                        <Handles>
                            {({ handles, getHandleProps }) => (
                                <div className="slider-handles">
                                    {handles.map(handle => (
                                        <MuiHandle
                                            key={handle.id}
                                            handle={handle}
                                            domain={state.domain}
                                            getHandleProps={getHandleProps}
                                        />
                                    ))}
                                </div>
                            )}
                        </Handles>
                        {/*<Tracks left={false} right={false}>*/}
                        {/*    {({ tracks, getTrackProps }) => (*/}
                        {/*        <div className="slider-tracks">*/}
                        {/*            {tracks.map(({ id, source, target }) => (*/}
                        {/*                <MuiTrack*/}
                        {/*                    key={id}*/}
                        {/*                    source={source}*/}
                        {/*                    target={target}*/}
                        {/*                    getTrackProps={getTrackProps}*/}
                        {/*                />*/}
                        {/*            ))}*/}
                        {/*        </div>*/}
                        {/*    )}*/}
                        {/*</Tracks>*/}
                        {/*<Ticks count={5}>*/}
                        {/*    {({ ticks }) => (*/}
                        {/*        <div className="slider-ticks">*/}
                        {/*            {ticks.map(tick => (*/}
                        {/*                <MuiTick key={tick.id} tick={tick} count={ticks.length} />*/}
                        {/*            ))}*/}
                        {/*        </div>*/}
                        {/*    )}*/}
                        {/*</Ticks>*/}
                    </Slider>
                    <Grid
                        container
                        alignItems="center"
                        justify="space-around"
                        style={{ marginTop: "16px" }}
                    >
                        <Grid item xs style={{ textAlign: "right" }}>
                            <TextField
                                size="small"
                                fullWidth={true}
                                variant="outlined"
                                label="starting price"
                                value={state.inputValues[0]}
                                onChange={evt => {
                                    console.log(evt);
                                    const value = evt.target.value;
                                    console.log(value);
                                    setState(a => ({ ...a, inputValues: [value, a.inputValues[1]] }))
                                    //this.setState({ inputValues: newState });
                                    if (value && value >= state.domain[0]) {
                                        console.log("IF HIT");
                                        setState(a => ({ ...a, values: [value, a.inputValues[1]] }))
                                        //this.setState({ values: newState });
                                    }
                                }}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">£</InputAdornment>
                                    )
                                }}
                            />
                        </Grid>
                        <Grid item xs={1} style={{ textAlign: "center" }}>
                            -
                        </Grid>
                        <Grid item xs style={{ textAlign: "left" }}>
                            <TextField
                                size="small"
                                fullWidth={true}
                                variant="outlined"
                                label="max price"
                                value={state.inputValues[1]}
                                onChange={evt => {
                                    const value = evt.target.value;
                                    setState(a => ({ ...a, inputValues: [state.inputValues[0], value] }))
                                    //this.setState({ inputValues: newState });
                                    if (value && value <= state.domain[1] && value >= state.values[0]) {

                                        setState(a => ({ ...a, values: [state.inputValues[0], value] }))
                                        //this.setState({ values: newState });
                                    }
                                }}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">£</InputAdornment>
                                    )
                                }}
                            />
                        </Grid>
                    </Grid>
                </div>
            </Grid>
        </Grid>
    );
}


export default memo(HistoSlider);
